import React , { useState, useEffect }  from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";

export default function Navbar(props ) {
  const history = useHistory();
  // Inside the Navbar component
const { isOpen, setIsOpen } = props;

  let user_status = localStorage.getItem("status");
  let name = localStorage.getItem("name");

  function logout() {
    localStorage.clear("token");
    history.push("/");
  }
 
  const handleBtnClick = () => {
    setIsOpen(prev => !prev); // Toggle isOpen
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-white fixed-top">
      <div className="container-fluid">
        <div className="collapse navbar-collapse justify-content-end">
          <ul className="navbar-nav">
            <li className="nav-item dropdown">
              <a
                className="nav-link text-capitalize"
                href="javascript:;"
                id="navbarDropdownProfile"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <b style={{ fontSize: 15, color: "#FC3538" }}>Welcome {name}</b>{" "}
                <i
                  className="material-icons"
                  style={{ fontSize: 25, color: "#FC3538" }}
                >
                  person
                </i>
                <p className="d-lg-none d-md-block">Account</p>
              </a>
              <div
                className="dropdown-menu dropdown-menu-right"
                aria-labelledby="navbarDropdownProfile"
              >
                {user_status === "admin" ? (
                  <div></div>
                ) : (
                  <Link to="/company-detail" className="dropdown-item">
                    Company Profile
                  </Link>
                )}
                <Link to="/setting" className="dropdown-item">
                  Setting
                </Link>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item" href="#" onClick={() => logout()}>
                  Logout
                </a>
              </div>
            </li>
          </ul>
        </div>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          aria-controls="navigation-index"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={handleBtnClick}
        >
          <span className="sr-only">Toggle navigation</span>
          <span className="navbar-toggler-icon icon-bar"></span>
          <span className="navbar-toggler-icon icon-bar"></span>
          <span className="navbar-toggler-icon icon-bar"></span>
        </button>
      </div>
    </nav>
  );
}
